module.exports = __webpack_public_path__ + "a87472dbae7cbce0561487a1b1dc74e3.svg";